import Cookies from "js-cookie";

export const SessionService = {
    setCookie,
    removeCookie,
    getCookie
};

function setCookie(name, value, config) {
    let expireTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000); // 24 hrs expire
    Cookies.remove(name);
    if(config) {
        Cookies.set(name, value, { ...config });
    } else {
        Cookies.set(name, value, { expires: expireTime });
    }
}

function removeCookie(name, config) {
    if(config) {
        Cookies.remove(name, config);
    } else {
        Cookies.remove(name);
    }
}

function getCookie(name) {
    const cookieObj = Cookies.get(name);
    if(cookieObj === undefined || typeof cookieObj === 'string' || cookieObj instanceof String) {
        return cookieObj;
    }
    return JSON.parse(cookieObj);
};

export default SessionService;